import { Panel } from "reactflow";
import { useEffect, useState } from "react";
import { debounce } from "lodash";
import { WindowSizeManager } from "@uikit/manager/WindowSizeManager";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { getIt } from "@uikit/getIt";
import { WindowSizeStore } from "@uikit/store/WindowSizeStore";

const AutoResizablePanel = (props: any) => {
  const { children, ...childProps } = props;
  const windowSizeManager = WindowSizeManager.use();
  const windowSizeState = useStore(getIt(WindowSizeStore)).value;
  const [zoom, setZoom] = useState(windowSizeManager.getBodyZoom());

  const handleZoom = () => {
    setZoom(windowSizeState.zoom);
  };

  useEffect(() => {
    debounce(handleZoom, 200)();
  }, [windowSizeState.zoom]);

  return (
    <>
      <Panel style={{ zoom: zoom }} {...childProps}>
        {children}
      </Panel>
    </>
  );
};

export default AutoResizablePanel;
